module.exports = __webpack_public_path__ + "main/assets/public/share-icons/email.4ced1975b38b6aca.svg";